import {
    RECIPIENTS,
    SUBJECT_MAX_LENGTH,
    SUPPORT_SUBJECT_BASE,
    BUSINESS_DEVELOPMENT_SUBJECT_BASE,
    toCharacters,
} from '../config/constants';

const SEPARATOR = ' - ';

const TRUNCATION_SUFFIX = '…';

const clampToLimit = (subject) => {
    const characters = toCharacters(subject);

    if (characters.length <= SUBJECT_MAX_LENGTH) {
        return subject;
    }

    return characters.slice(0, SUBJECT_MAX_LENGTH).join('');
};

const buildSupportSubject = (clientId) => {
    const trimmedClientId = (clientId || '').trim();

    if (!trimmedClientId) {
        return SUPPORT_SUBJECT_BASE;
    }

    return `${SUPPORT_SUBJECT_BASE}${SEPARATOR}${trimmedClientId}`;
};

const buildBusinessDevelopmentSubject = (companyName) => {
    const companyNameCharacters = toCharacters((companyName || '').trim());

    if (companyNameCharacters.length === 0) {
        return BUSINESS_DEVELOPMENT_SUBJECT_BASE;
    }

    const availableLength = SUBJECT_MAX_LENGTH
        - toCharacters(BUSINESS_DEVELOPMENT_SUBJECT_BASE).length
        - SEPARATOR.length;

    if (companyNameCharacters.length <= availableLength) {
        return `${BUSINESS_DEVELOPMENT_SUBJECT_BASE}${SEPARATOR}${companyNameCharacters.join('')}`;
    }

    const truncatedCompanyName = companyNameCharacters
        .slice(0, availableLength - TRUNCATION_SUFFIX.length)
        .join('')
        .replace(/\s+$/, '')
        .concat(TRUNCATION_SUFFIX);

    return `${BUSINESS_DEVELOPMENT_SUBJECT_BASE}${SEPARATOR}${truncatedCompanyName}`;
};

const buildContactSubject = (recipient, { companyName, clientId }) => clampToLimit(
    recipient === RECIPIENTS.support
        ? buildSupportSubject(clientId)
        : buildBusinessDevelopmentSubject(companyName),
);

export default buildContactSubject;
